import { findCollectionStatic } from '../../../Model/avenyStaticModelUtils';
import { getAttributes } from '../../../Model/avenyModelUtils';

export const getDebugFalt = (collectionName: string): string[] => {
  const collection = findCollectionStatic(collectionName);
  if (collection) {
    return getAttributes(collection).reduce<string[]>((acc, x) => {
      if (x.AttributeName.toLowerCase() !== '_version') {
        acc.push(x.AttributeName);
      }
      return acc;
    }, []);
  }
  return [];
};

export const getAssociations = (collectionName: string) => {
  const collection = findCollectionStatic(collectionName);
  if (collection) {
    return Object.values(collection.Associations);
  }
  return [];
};
